import { LoadActiveSearchStatistics } from 'domain/usecases/active-search/load-active-search-statistics'
import { ActiveSearchRepository } from 'repository/repositories/active-search/active-search-repository'

export class RemoteLoadActiveSearchStatistics
  implements LoadActiveSearchStatistics
{
  constructor(
    private readonly activeSearchRepository: ActiveSearchRepository
  ) {}

  load(
    params: LoadActiveSearchStatistics.Params
  ): Promise<LoadActiveSearchStatistics.Model> {
    return this.activeSearchRepository.loadActiveSearchStatistics(params)
  }
}
